import { MDSSessionConfig, SessionStatus } from "@/mds/components/sessions/session.types";
import { SessionViewMode } from "@/mds/components/sessions/session.constants";
import { MDSSessionState, MDSSessionActionTypes } from "../mds-session-context.types";
import {
  calculateSessionItemsFromEvents,
  mdsSessionEventsReducer,
} from "./events/mds-session-context.events.reducer";
import { mdsSessionUiReducer } from "./ui/mds-session-context.ui.reducer";

type CreateInitialStateProps = {
  sessionEvents: MDSSessionState["events"]["sessionEvents"];
  sessionStatus: SessionStatus;
  sessionConfig: MDSSessionConfig;
};

export const createInitialState = ({
  sessionEvents,
  sessionStatus,
}: CreateInitialStateProps): MDSSessionState => {
  const previewStatuses = [SessionStatus.Initial, SessionStatus.Unknown];
  const initiallyPreview = previewStatuses.includes(sessionStatus);
  const { items: sessionItems, itemIdCache: sessionItemIdCache } = calculateSessionItemsFromEvents({
    events: sessionEvents,
    toggleState: {},
    itemIdCache: {},
  });

  return {
    events: {
      sessionEvents,
      sessionItems,
      sessionStatus,
      sessionItemIdCache: sessionItemIdCache,
      sessionItemToggleState: {},
    },
    ui: {
      activeArtifact: null,
      isMinimized: false,
      countdownDurationMs: 0,
      isCountdownActive: false,
      isCountdownPaused: false,
      isInputFocused: false,
      isHovering: false,
      isInNotificationState: false,
      notificationInfo: null,
      sessionError: null,
      isPreview: initiallyPreview,
      sessionPrevMode: initiallyPreview ? SessionViewMode.Preview : SessionViewMode.Minimized,
    },
  };
};

/**
 * Root reducer that orchestrates all slice reducers
 */
export const mdsSessionReducer = (
  state: MDSSessionState,
  action: MDSSessionActionTypes
): MDSSessionState => {
  const events = mdsSessionEventsReducer(state.events, action);
  const ui = mdsSessionUiReducer(state.ui, action);

  return {
    events,
    ui,
  };
};
